import React from "react";
import CitizenEditComponent from "./CitizenEditComponent";

const CitizenEdit = () => {
  return <CitizenEditComponent />;
};

export default CitizenEdit;
